import type { AIPremadeTripWithOptionalImageUrl } from '../../models';

import { mapResponseToAIPremadeTrip } from './aiService.helper';

export class AIService {
  public async fetchAITripDetails(
    aiTripId: string
  ): Promise<AIPremadeTripWithOptionalImageUrl | undefined> {
    try {
      const apiUrl = this.getApiUrl(aiTripId);
      const response = await fetch(apiUrl);
      const jsonResponse = await response.json();
      return mapResponseToAIPremadeTrip(jsonResponse);
    } catch {
      throw new Error(
        'Could not fetch or parse AI trip content from smart search!'
      );
    }
  }

  private getApiUrl(aiTripId: string): string {
    return `https://smart-search.sembo.com/planneraicontent/additional-text?ai-trip-id=${aiTripId}`;
  }
}
